import React, { useState } from "react";
import { GoogleMap, Circle, InfoWindow, Marker } from "@react-google-maps/api";

const PredictiveMap = ({ hotspots, loader }) => {
    const [selectedCluster, setSelectedCluster] = useState(null);

    const mapContainerStyle = {
        width: "100%",
        height: "100%",
    };

    // Centro inicial (Guatemala/Quetzaltenango aproximado basado en los datos previos)
    const center = {
        lat: 14.8333,
        lng: -91.5167
    };

    const options = {
        fullscreenControl: false,
        streetViewControl: false,
        mapTypeControl: true,
        styles: [
            {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: [{ color: "#7c93a3" }]
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [{ color: "#c9d2d4" }]
            }
        ]
    };

    if (loader) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100 bg-light">
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-2 text-primary font-weight-bold">Analizando datos históricos...</p>
                </div>
            </div>
        );
    }

    return (
        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={13}
            center={hotspots.length > 0 ? { lat: hotspots[0].lat_cluster, lng: hotspots[0].lng_cluster } : center}
            options={options}
        >
            {hotspots.map((cluster, index) => {
                // Escalar radio e intensidad
                const radius = Math.min(300, 100 + (cluster.intensity * 10));
                const color = cluster.intensity > 10 ? "#dc3545" : cluster.intensity > 5 ? "#fd7e14" : "#ffc107";
                
                return (
                    <React.Fragment key={index}>
                        <Circle
                            center={{ lat: cluster.lat_cluster, lng: cluster.lng_cluster }}
                            radius={radius}
                            options={{
                                strokeColor: color,
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                                fillColor: color,
                                fillOpacity: 0.35,
                            }}
                            onClick={() => setSelectedCluster(cluster)}
                        />
                        {/* Marcador invisible para el InfoWindow si se desea */}
                        {selectedCluster === cluster && (
                            <InfoWindow
                                position={{ lat: cluster.lat_cluster, lng: cluster.lng_cluster }}
                                onCloseClick={() => setSelectedCluster(null)}
                            >
                                <div className="p-2">
                                    <h6 className="font-weight-bold text-danger mb-1">Zona de Alta Densidad</h6>
                                    <p className="mb-0 text-dark">
                                        Número de emergencias: <strong>{cluster.intensity}</strong>
                                    </p>
                                    <small className="text-muted">Basado en historial de 365 días.</small>
                                </div>
                            </InfoWindow>
                        )}
                    </React.Fragment>
                );
            })}
        </GoogleMap>
    );
};

export default PredictiveMap;
